import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, Flex, Form, Input, Row, Radio, Tooltip } from "antd";
import { SectionHeader } from "../../components/SectionHeader/SectionHeader";
import { getShipments } from "../Dashboard/dashboardSlice";
import { buildQueryString, debounce } from "../../utils/helpers";
import { HeaderCell } from "../Dashboard/HeaderCell";
import { IconDownload } from "../../components/IconDownload/IconDownload";
import { IconSearch } from "../../components/IconSearch/IconSearch";
import { MainButton } from "../../components/MainButton/MainButton";
import { Notification } from "../../components/Notification/Notification";
import { dateCell } from "../../components/DateCell/DateCell";
import { CSVLink } from "react-csv";
import dayjs from 'dayjs';
import Table from "../../components/SortableTable/SortableTable";

export const Shipments = ({upc}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [type, setType] = useState("invoice");
  const [sortDirection, setSortDirection] = useState("");
  const [showNotification, setShowNotification] = useState(false);

  const page = new URLSearchParams(location.search).get("page") || 1;
  const search = new URLSearchParams(location.search).get("search");
  const sort = new URLSearchParams(location.search).get("sort");

  const onQueryParamsChange = (values) => {
	const queryParams = {
	  upc,		
	  page,
	  search,
	  sort,
	  ...values,
	};
	//SetState?
	//const queryString = buildQueryString("/overview", queryParams);
	//navigate(queryString);
  };

  const { shipments, getShipmentsInProgress } =
	useSelector((state) => state?.dashboard) || {};

  const { data: rows, totalPages } = shipments || {};
  
  const [sortedTableData, setSortedTableData] = useState(rows);
  
  useEffect(() => {
	  if (rows && rows.length > 0) {
		  handleDataUpdate(rows);
	  }
  }, [rows]);

  
  const handleDataUpdate = (data) => {
    setSortedTableData(data);
  };

  useEffect(() => {
	dispatch(
	  getShipments({
		upc,  
		type,
		page,
		search,
		sort: sortDirection,
	  }),
	);
  }, [upc, type]);

  const columns = [
  {
	  title: "Territory",
	  editable: true,
	  dataIndex: "Territory",
	  sorter: true,
	  width: 100,
	  align: "left",
	  hide: type == 'customer',
	  showSorterTooltip: false,
	},

  {
	title: (
	  <Tooltip title="Customer account name">
		<div>Customer</div>
	  </Tooltip>
	),
	editable: true,
	dataIndex: "Customer",
	sorter: true,
	width: 200,
	align: "left",
	showSorterTooltip: false,
  },
  /*
  {
	title: "Invoice Description",
	editable: true,
	dataIndex: "InvoiceDescription",
	sorter: true,
	width: 250,
	align: "left",
  },
  */
  {
	title: (
	  <Tooltip title="Total sales to date - all direct sales accounts">
		<div>Direct Sales</div>
	  </Tooltip>
	),
	editable: true,
	dataIndex: "DirectSales",
	sorter: true,
	width: 100,
	align: "left",
	showSorterTooltip: false,
	defaultSortOrder: 'descend', 
  },
  {
	title: (
	  <Tooltip title="Date of last shipment to this account">
		<div>Invoice Ship Last</div>
	  </Tooltip>
	),

	editable: true,
	dataIndex: "InvoiceShipLast",
	sorter: true,
	width: 150,
	align: "left",
	render: (record) => dateCell(record),
	
	showSorterTooltip: false,
  },
].filter(column=>!column.hide);

  const exportedCSVFile = `Direct-Sales-${upc}-${dayjs().format('YYYY-MM-DD')}.csv`;
  
  return (
		<Flex className={""} vertical>
			<Flex style={{
				marginBottom: "16px"
			}}>
				<Radio.Group value={type} onChange={(e)=>setType(e.target.value)}>
					<Radio.Button value="invoice"><Tooltip title="Direct sales per invoiced order">Invoice</Tooltip></Radio.Button>
					<Radio.Button value="customer"><Tooltip title="Total direct sales to date by customer">Customer</Tooltip></Radio.Button>
				</Radio.Group>
			</Flex>

			<SectionHeader title="Direct Sales">
				<CSVLink data={Array.isArray(sortedTableData) ? sortedTableData.map(({ Key, ...rest }) => rest) : []} filename={exportedCSVFile} >
					<IconDownload />
				</CSVLink>
			</SectionHeader>
			<Table
				components={{
					header: {
						row: HeaderCell,
					},
				}}
				columns={columns}
				rowKey={(record) => record.Key}
				dataSource={rows}
				onDataChange={handleDataUpdate}
				pagination={{
					position: ["bottomRight"],
					responsive: true,
					total: totalPages * 10,
					pageSize: 10,
					hideOnSinglePage: true,
					showSizeChanger: false,
				}}
				loading={getShipmentsInProgress}
				style={{ marginTop: 10 }}
				scroll={{ x: "100%" }}
			/>
		</Flex>
  );
};
